<template>
  <ModalBase @close-modal="() => closeEventConfirmModal()">
    <div class="modalLayout">
      <div class="modalContainer">
        <p class="modalTitle">
          ご視聴により同一チャンネルに参加されている下記病院に会員情報を提供させていただきます。
        </p>
        <p>
          ■提供先病院名
        </p>
        <ul v-if="hospitals">
          <li v-for="(hospital, i) in hospitals" :key="i">
            {{ hospital }}
          </li>
        </ul>

        <div class="modalBtns">
          <Button
            :handle-click="openEventModal"
            label="上記了解し視聴する"
            secondary
          />
          <Button :handle-click="closeModal" label="視聴しない" border />
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
dayjs.locale('ja')
export default defineComponent({
  name: 'ModalOnlineEventConfirm',

  components: {
    ModalBase,
    Button
  },

  props: {
    closeEventConfirmModal: {
      type: Function as PropType<() => void>,
      required: true
    },
    openEventModal: {
      type: Function as PropType<() => void>,
      required: true
    },
    hospitals: {
      type: Array as PropType<string[]>
    }
  },

  setup(props) {
    const store = useStore()

    const closeModal = () => {
      store.commit('unFixBody')
      props.closeEventConfirmModal()
    }

    return {
      closeModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep .modal {
  height: calc(100% + 40px);
  width: 100%;
  max-width: 1088px;
  margin-top: 20px;
  padding-right: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mixins.media() {
    height: 100%;
    margin-top: 0;
    margin-left: 20px;
    margin-right: 20px;
    padding-left: 40px;
    padding-right: 15px;
  }
}
.modalLayout {
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  @include mixins.media() {
    padding-right: 30px;
    padding-left: 12px;
  }
}

.modalContainer {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
  max-width: 744px;
  margin-left: auto;
  margin-right: auto;
}

::v-deep(.modalInfo_description > a) {
  color: var.$color-main-text;
}
.modalBtns {
  display: grid;
  gap: 20px;
  margin-top: 24px;
  @include mixins.media() {
    display: flex;
    justify-content: center;
    > button {
      margin: 0 !important;
    }
  }
}
.modalTitle {
  font-weight: bold;
}
</style>
